import { FormControl, FormField, FormItem, FormLabel } from "@/components/ui/form"
import { Textarea } from "@/components/ui/textarea"
import { useTranslations } from "next-intl"

interface ContactMessageFieldProps {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  form: any
  label?: string | null
  required?: boolean
}

const ContactMessageField = ({ form, label }: ContactMessageFieldProps) => {
  const t = useTranslations("ContactForm")
  const displayLabel = (label?.trim()) || t("message")

  return (
    <FormField
      control={form.control}
      name="message"
      render={({ field }) => (
        <FormItem className="space-y-2">
          <FormLabel htmlFor="message">{displayLabel}</FormLabel>
          <FormControl>
            <Textarea
              id="message"
              className="glass-panel min-h-[100px]"
              {...field}
            />
          </FormControl>
        </FormItem>
      )}
    />
  )
}

export default ContactMessageField